<template>
  <section class="content">
    <WatchGenerator/>
  </section>
</template>

<script>
import WatchGenerator from './nodes_overview/WatchGenerator.vue'
export default {
  components: {
    WatchGenerator
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/NodesOverview.vue